import React, { Component } from 'react';
import Plx from 'react-plx';
import { Link } from 'react-scroll';

const bgBlurParallaxData = [
	{
	  start: 'self',
	  end: '100vh',
	  properties: [
			{
				startValue: 0,
				endValue: 400,
				property: 'translateY'
			}
	  ]
	}
];

const middleLayerParallaxData = [
	{
	  start: 'self',
	  end: '100vh',
	  properties: [
			{
				startValue: 0,
				endValue: 300,
				property: 'translateY'
			}
	  ]
	}
];

const centerParallaxData = [
	{
	  start: 'self',
	  end: '100vh',
	  properties: [
			{
				startValue: 0,
				endValue: 200,
				property: 'translateY'
			}
	  ]
	}
];

const frontParallaxData1 = [
	{
	  start: 'self',
	  end: '100vh',
	  properties: [
			{
				startValue: 0,
				endValue: 100,
				property: 'translateY'
			}
	  ]
	}
];

const frontParallaxData2 = [
	{
	  start: 'self',
	  end: '100vh',
	  properties: [
			{
				startValue: 0,
				endValue: 50,
				property: 'translateY'
			}
	  ]
	}
];

export default class TopHero extends Component {

	render() {
		return(
			<header className='top-hero'>
				<Plx
					parallaxData = {bgBlurParallaxData}
					className = 'parallax-bg-blur-image'
				>
					<div className='left-image'>
						<img src='https://cdn.couponology.com/images/mediakit-background-blur-leftAsset_1.png' alt='Left background blur' />
					</div>
					<div className='right-image'>
						<img src='https://cdn.couponology.com/images/mediakit-background-blur-rightAsset_1.png' alt='Right background blur' />
					</div>
				</Plx>
				<Plx
					parallaxData = {middleLayerParallaxData}
					className = 'parallax-middle-layer-image'
				>
					<div className='right-image'>
						<img src='https://cdn.couponology.com/images/mediakit-middle-layer-rightAsset_1.png' alt='Right middle layer' />
					</div>
				</Plx>
				<Plx
					parallaxData = {centerParallaxData}
					className = 'parallax-center-image'
				>
					<div className='center-image'>
						<img src='https://cdn.couponology.com/images/mediakit-centerAsset_1.png' alt='Center background' />
					</div>
				</Plx>
				<Plx
					parallaxData = {middleLayerParallaxData}
					className = 'parallax-middle-layer-image'
				>
					<div className='left-image'>
						<img src='https://cdn.couponology.com/images/mediakit-middle-layer-leftAsset_1.png' alt='Left middle layer' />
					</div>
				</Plx>
				<Plx
					parallaxData = {frontParallaxData1}
					className = 'parallax-front-layer1-image'
				>
					<div className='left-image'>
						<img src='https://cdn.couponology.com/images/mediakit-front-leftAsset_1.png' alt='Left front layer' />
					</div>
					<div className='right-image'>
						<img src='https://cdn.couponology.com/images/mediakit-front-rightAsset_1.png' alt='Right front layer' />
					</div>
				</Plx>
				<Plx
					parallaxData = {frontParallaxData2}
					className = 'parallax-front-layer2-image'
				>
					<div className='left-image'>
						<img src='https://cdn.couponology.com/images/mediakit-front-leftAsset_2.png' alt='Left front layer' />
					</div>
					<div className='right-image'>
						<img src='https://cdn.couponology.com/images/mediakit-front-rightAsset_2.png' alt='Right front layer' />
					</div>
				</Plx>
				<div className='top-hero-text'>
					<h1>media opportunities</h1>
					<p>
					Give your online marketing the edge it needs.  Couponology can tailor a unique campaign that will drive more traffic, deliver new acquisitions, create higher conversions, and guarantee a ROAS.
					</p>
					<Link
								to="highlights"
								spy={true}
								smooth={true}
								offset={-70}
								duration= {700}
								className="learn-more-btn"
							>
								learn more
							</Link>
				</div>
			</header>
		);
	}
}